<template>
    <div>
    <footer>
        <div class="columns is-multiline is-centered">
            <div class="column is-two-thirds">
                <hr>
                <nav class="level">
                    <div v-if="phone.length" class="level-item has-text-centered">
                        <div>
                        <p class="heading">Telefono</p>
                        <p class="has-text-weight-bold">{{phone}}</p>
                        </div>
                    </div>
                    <div v-if="email.length" class="level-item has-text-centered">
                        <div>
                        <p class="heading">Email</p>
                        <p class="has-text-weight-bold">{{email}}</p>
                        </div>
                    </div>
                    <div v-if="direccion.length > 3" class="level-item has-text-centered">
                        <div>
                        <p class="heading">Direccion</p>
                        <p class="has-text-weight-bold">{{direccion}}</p>
                        </div>
                    </div>
                    <div v-if="localidad.length" class="level-item has-text-centered">
                        <div>
                        <p class="heading">Localidad</p>
                        <p class="has-text-weight-bold">{{localidad}}</p>
                        </div>
                    </div>
                </nav>
            </div>
            <div v-if="mpChannel=='True' || paypalChannel=='True'" class="column is-half m-t-10">
                <p class="heading has-text-centered">
                    Pagos por medio de
                </p>
                <nav class="level has-text-centered">
                    <div v-if="mpChannel=='True'" class="level-item has-text-centered">
                        <a target="_blank" class="has-text-dark" href="https://www.mercadopago.com.uy/cuotas">
                            <img height="30px" src="https://traction-prod.ams3.digitaloceanspaces.com/Untitled-1.png" alt="">
                        </a>
                    </div>
                    <div v-if="paypalChannel=='True'" class="level-item has-text-centered">
                        <a target="_blank" class="has-text-dark" href="https://www.paypal.com/uy/webapps/mpp/home">
                            <img height="30px" src="https://traction-prod.ams3.digitaloceanspaces.com/Untitled-2.png" alt="">
                        </a>
                    </div>
                    <div 
                    v-if="['retailer-1.localhost:8000', 'fedysel.com.uy', 'www.fedysel.com.uy', 'fedysel.traction.cloud'].includes(siteDomain)" 
                    class="level-item has-text-centered">
                        <a>
                            <img src="https://traction-prod.ams3.digitaloceanspaces.com/fedysel-payments.png" alt="">
                        </a>
                    </div>
                </nav>
                <p class="has-text-centered" v-if="['retailer-1.localhost:8000', 'fedysel.com.uy', 'www.fedysel.com.uy', 'fedysel.traction.cloud'].includes(siteDomain)">
                    Envios a todo el pais!
                </p>
            </div>
        </div>
        

        <b-modal :active.sync="privacyPolicyModal" scroll="keep">
            <div class="modal-card" style="width: auto">
                
                <div class="modal-card-body">
                    <Privacy/>
                    <div class="has-text-centered">
                        <b-button
                        type="is-danger"
                        @click="privacyPolicyModal=false">
                        Cerrar</b-button>
                    </div>
                </div>
                
            </div>
        </b-modal>

    </footer>
    
    <footer class="footer">
        <div class="columns">
            <div class="column is-full">
                <nav class="level is-mobile">
                    <div class="level-item has-text-centered">
                        <div>
                        <p class="heading">Powered By</p>
                        <a class="has-text-dark" href="https://traction.cloud">
                            <img style="max-height:18px; vertical-align:centered;" src="../../../assets/logo.png" alt="traction-logo">
                        </a>
                        <p class="is-size-7">©  Traction.</p>
                        <a
                        class="m-t-10 heading has-text-dark"
                        @click="privacyPolicyModal=true"
                        >
                            Politica de privacidad
                        </a>
                        
                        </div>
                    </div>
                </nav>
                
            </div>
        </div>
    </footer>
    
    </div>
</template>

<script>
import Privacy from "./components/Privacy.vue"
export default {
    components:{
        Privacy
    },
    props:{
        phone:{
            type:String,
            default:""
        },
        email:{
            type:String,
            default:""
        },
        direccion:{
            type:String,
            default:""
        },
        localidad:{
            type:String,
            default:""
        },
        companyLogo:{
            type:String,
            default:""
        },
        mpChannel:{
            type:String,
            default:""
        },
        paypalChannel:{
            type:String,
            default:""
        },
        userSettingsUrl:{
            type:String,
            default:""
        },
        contactoUrl:{
            type:String,
            default:""
        },
        carritoUrl:{
            type:String,
            default:""
        },
        siteDomain:{
            type:String,
            default:""
        },
        isB2b:{
            type:String,
            default:""
        },
        isStore:{
            type:String,
            default:""
        },
        isContent:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            privacyPolicyModal:false
        }
    },
    computed:{
        b2bBool(){
            return this.isB2b === 'True'
        },
        contentBool(){
            return this.isContent === 'True'
        },
        storeBool(){
            return this.isStore === 'True'
        },
        isMobile(){
            var storageKey = localStorage.getItem("ismobile")
            console.log(storageKey == 'false')
            return storageKey == 'true';
        }
    }
}
</script>
<style lang="scss" scoped>
.footer{
    margin-top:25px;
    margin-bottom: 0px !important;
    background: rgb(238, 238, 238);
}
</style>